// extracted by mini-css-extract-plugin
export var contrastLow = "_k-1";
export var externalLink = "_k-2";
export var externalLinkIcon = "_k-3";
export var link = "_k-0";
export var linkLabel = "_k-4";